<template>
  <div class="ModalComponent">

    <b-modal v-model="isModalComponent" no-close-on-esc no-close-on-backdrop :title="modalTitle"
      :header-bg-variant="theme.headerBgVariant" :header-text-variant="theme.headerTextVariant"
      :body-bg-variant="theme.bodyBgVariant" :body-text-variant="theme.bodyTextVariant"
      :footer-bg-variant="theme.footerBgVariant" :footer-text-variant="theme.footerTextVariant"
      :size="modalComponentObject.size" :hide-header-close="hideHeaderClose" scrollable>
      <br>
      <b-container v-if="modalComponentObject.type == 'dashboard_settings'" fluid>
        <DashboardSettingsComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </DashboardSettingsComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_property'" fluid>
        <CreatePropertyComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></CreatePropertyComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_user'" fluid>
        <CreateUserComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></CreateUserComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'update_user'" fluid>
          <UpdateUserComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></UpdateUserComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'new_group'" fluid>
          <CreateGroupComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></CreateGroupComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'update_group'" fluid>
          <UpdateGroupComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></UpdateGroupComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'footprints'" fluid>
        <FootprintComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
          :selected="modalComponentObject.selected"></FootprintComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'symbols'" fluid>
        <SymbolComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
          :selected="modalComponentObject.selected" :data="modalComponentObject.data"></SymbolComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'altsymbols'" fluid>
          <AltSymbolsComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
            :selected="modalComponentObject.selected"></AltSymbolsComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'libraries'" fluid>
          <LibrariesComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
            :selected="modalComponentObject.selected" :data="modalComponentObject.data"></LibrariesComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'notifications'" fluid>
        <NotificationTableComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </NotificationTableComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'eventtaskform'" fluid>
        <EventTaskFormComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
          :data="modalComponentObject.data">
        </EventTaskFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_project'" fluid>
        <CreateProjectComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></CreateProjectComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'update_project'" fluid>
        <UpdateProjectComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></UpdateProjectComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_project_revision'" fluid>
        <CreateNewProjectRevComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </CreateNewProjectRevComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_library_property'" fluid>
        <CreateLibraryPropertyComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </CreateLibraryPropertyComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'new_project_property'" fluid>
          <CreateProjectPropertyComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
          </CreateProjectPropertyComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'zoom_svg'" fluid>
        <ZoomSvgComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"
          :svgObject="modalComponentObject.svgObject"></ZoomSvgComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'push_files'" fluid>
        <PushComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme" :data="modalComponentObject.data">
        </PushComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'bulk_feedback'" fluid>
          <BulkFeedbackComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme" :data="modalComponentObject.data">
          </BulkFeedbackComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'new_libraries_request'" fluid>
        <NewLibrariesRequestComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme" :data="modalComponentObject.data">
        </NewLibrariesRequestComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'create_subfolder_project'" fluid>
        <CreateSubfolderFormComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </CreateSubfolderFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'import_bom_type'" fluid>
        <ImportBomTypeFormComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </ImportBomTypeFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'import_file_tree'" fluid>
        <ImportFileFormComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></ImportFileFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'renaming'" fluid>
        <RenamingComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></RenamingComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'moving'" fluid>
        <MovingComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></MovingComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'delegation'" fluid>
        <DelegationComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme"></DelegationComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'transferownership'" fluid>
        <TransferOwnershipComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </TransferOwnershipComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'createbomvariant'" fluid>
        <CreateBomVariantFormComponent :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </CreateBomVariantFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'bompartform'" fluid>
        <BomPartObjectFormComponent :data="modalComponentObject.data" :lang="modalComponentObject.lang" v-bind:class="usingTheme">
        </BomPartObjectFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'assemblyquantity'" fluid>
        <AssemblyQuantityFormComponent :data="modalComponentObject.data" :lang="modalComponentObject.lang"
          v-bind:class="usingTheme">
        </AssemblyQuantityFormComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'eventtaskValidation'" fluid>
        <EventTaskValidationComponent :data="modalComponentObject.data" :lang="modalComponentObject.lang"
          v-bind:class="usingTheme">
        </EventTaskValidationComponent>
      </b-container>
      <b-container v-if="modalComponentObject.type == 'SERisk'" fluid>
          <SERiskComponent :data="modalComponentObject.data" :lang="modalComponentObject.lang"
            v-bind:class="usingTheme">
          </SERiskComponent>
        </b-container>
      <b-container v-if="modalComponentObject.type == 'pinAnalysis'" fluid>
          <PinAnalysisComponent :data="modalComponentObject.data" :lang="modalComponentObject.lang"
            v-bind:class="usingTheme">
          </PinAnalysisComponent>
        </b-container>
      <br>

      <div slot="modal-footer" class="w-100">
        <span v-if="modalComponentObject.buttons == 2">

          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="no" @keyup.enter="keyup" :disabled="cancelDisabled">
            Cancel
          </b-btn>
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="yes"
            @keyup.enter="keyup" :disabled="okDisabled">
            OK
          </b-btn>
        </span>
        <span v-if="modalComponentObject.buttons == 1">
          <b-btn size="sm" class="btn float-right" :variant="theme.btnVariant" @click="Custom"
            @keyup.enter="Custom" :disabled="customDisabled">
            {{modalComponentObject.buttonName}}
          </b-btn>

        </span>

      </div>
    </b-modal>
  </div>
</template>

<script>
import DashboardSettingsComponent from '@/components/shared/DashboardSettingsComponent'
import CreatePropertyComponent from '@/components/shared/CreatePropertyComponent'
import CreateUserComponent from '@/components/shared/CreateUserComponent'
import UpdateUserComponent from '@/components/shared/UpdateUserComponent'
import CreateGroupComponent from '@/components/shared/CreateGroupComponent'
import UpdateGroupComponent from '@/components/shared/UpdateGroupComponent'
import FootprintComponent from '@/components/shared/FootprintComponent'
import LibrariesComponent from '@/components/shared/LibrariesComponent'
import SymbolComponent from '@/components/shared/SymbolComponent'
import NotificationTableComponent from "@/components/shared/NotificationTableComponent"
import EventTaskFormComponent from "@/components/shared/EventTaskFormComponent"
import CreateProjectComponent from "@/components/shared/CreateProjectComponent"
import UpdateProjectComponent from "@/components/shared/UpdateProjectComponent"
import CreateNewProjectRevComponent from "@/components/shared/CreateNewProjectRevComponent"
import CreateLibraryPropertyComponent from "@/components/shared/CreateLibraryPropertyComponent"
import ZoomSvgComponent from '@/components/shared/ZoomSvgComponent'
import PushComponent from '@/components/shared/PushComponent'
import CreateSubfolderFormComponent from '@/components/shared/CreateSubfolderFormComponent'
import ImportFileFormComponent from '@/components/shared/ImportFileFormComponent'
import RenamingComponent from '@/components/shared/RenamingComponent'
import MovingComponent from '@/components/shared/MovingComponent'
import DelegationComponent from '@/components/shared/DelegationComponent'
import TransferOwnershipComponent from '@/components/shared/TransferOwnershipComponent'
import ImportBomTypeFormComponent from '@/components/shared/ImportBomTypeFormComponent'
import CreateBomVariantFormComponent from '@/components/shared/CreateBomVariantFormComponent'
import BomPartObjectFormComponent from '@/components/shared/BomPartObjectFormComponent'
import AssemblyQuantityFormComponent from '@/components/shared/AssemblyQuantityFormComponent'
import NewLibrariesRequestComponent from '@/components/shared/NewLibrariesRequestComponent'
import EventTaskValidationComponent from '@/components/shared/EventTaskValidationComponent'
import CreateProjectPropertyComponent from '@/components/shared/CreateProjectPropertyComponent'
import SERiskComponent from '@/components/shared/SERiskComponent'
import AltSymbolsComponent from '@/components/shared/AltSymbolsComponent'
import PinAnalysisComponent from '@/components/shared/PinAnalysisComponent'
import BulkFeedbackComponent from '@/components/shared/BulkFeedbackComponent'

export default {
  name: 'ModalComponent',
  components: {
    DashboardSettingsComponent,
    CreatePropertyComponent,
    CreateUserComponent,
    UpdateUserComponent,
    CreateGroupComponent,
    UpdateGroupComponent,
    FootprintComponent,
    LibrariesComponent,
    SymbolComponent,
    NotificationTableComponent,
    EventTaskFormComponent,
    CreateProjectComponent,
    UpdateProjectComponent,
    CreateNewProjectRevComponent,
    CreateLibraryPropertyComponent,
    ZoomSvgComponent,
    PushComponent,
    CreateSubfolderFormComponent,
    ImportFileFormComponent,
    RenamingComponent,
    MovingComponent,
    DelegationComponent,
    TransferOwnershipComponent,
    ImportBomTypeFormComponent,
    CreateBomVariantFormComponent,
    BomPartObjectFormComponent,
    AssemblyQuantityFormComponent,
    NewLibrariesRequestComponent,
    EventTaskValidationComponent,
    CreateProjectPropertyComponent,
    SERiskComponent,
    AltSymbolsComponent,
    PinAnalysisComponent,
    BulkFeedbackComponent


  },
  data () {
    return {
           
      hideHeaderClose: true,
      okDisabled: false,
      cancelDisabled: false,
      customDisabled: false,
      
    }
  },
  computed: {
    usingTheme(){
      return this.theme.modal
    },
    modalTitle(){
      
      
      if (this.modalComponentObject.lang == undefined){
        return ""
      }
      
      return this.modalComponentObject.lang.modal_Title;
    },
    isModalComponent:{

      get() {
        return this.$store.getters.isModalComponent
      },
      set(value) {

        //this.$store.commit('SHOWALERT', false);
      },
    },
    modalComponentObject(){

      let o = this.$store.getters.modalComponentObject;
      if (o.noCloseOnBackdrop == undefined){
        o.noCloseOnBackdrop = false;
      }
      if (o.noCloseOnEsc == undefined){
        o.noCloseOnEsc = false;
      }

      return o;
    },
    theme(){

      const obj = {};
      if (this.$store.getters.s_skinVariant == "light"){
        obj.headerBgVariant = 'light';
        obj.headerTextVariant = 'dark';
        obj.bodyBgVariant = 'white';
        obj.bodyTextVariant = 'dark';
        obj.footerBgVariant = 'light';
        obj.footerTextVariant = 'dark';
        obj.btnVariant = 'dark';
        obj.modal = '--lightModal';

      }else if (this.$store.getters.s_skinVariant == "dark"){
        obj.headerBgVariant = 'dark';
        obj.headerTextVariant = 'light';
        obj.bodyBgVariant = 'dark';
        obj.bodyTextVariant = 'light';
        obj.footerBgVariant = 'dark';
        obj.footerTextVariant = 'light';
        obj.btnVariant = 'light';
        obj.modal = '--darkModal';
      }
      return obj;
    },
    buttonsStateModalObject() {
      return this.$store.getters.buttonsStateModalObject
    }

  },
  created() {
    const objModal = {
      ok: false,
      cancel: false
    }

    this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)
  },
  watch: {
    isModalComponent: function (newVal, oldVal) {
      
      if (newVal == true){
        
        let vue = this;

        setTimeout(function () {

          let fade = document.getElementsByClassName("modal fade");
          if (fade != null){
            fade[0].addEventListener("click", function(e){
            
            if (e.target.className == "modal fade show"){
              //vue.$store.dispatch("hideModalComponent");
            }
          })
          }
          

        },1000)

      }
    },
    buttonsStateModalObject: {
          handler: function(newVal){
            

            if (newVal.ok != (undefined || null)) {
              
              if (newVal.ok == true) {
                this.okDisabled = true;
              } else {
                this.okDisabled = false;
              }
            }
            if (newVal.cancel != (undefined || null)) {
              
              if (newVal.cancel == true) {
                this.cancelDisabled = true;
              } else {
                 this.cancelDisabled = false;
              }
            }
            if (newVal.custom != (undefined || null)) {
              
              if (newVal.custom == true) {
                this.customDisabled = true;
              } else {
                this.customDisabled = false;
              }
            }
          },
          deep: true
        
          
        },
  },
  methods: {
    yes: function(){
      this.$store.dispatch("hideModalComponent");

       const objModal = {
        ok: false,
        cancel: false
      }

      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)


      if (this.modalComponentObject.funcYes != ""){
        this.modalComponentObject.funcYes(this);
      }


    },
    no: function(){
      this.$store.dispatch("hideModalComponent");

       const objModal = {
        ok: false,
        cancel: false
      }

      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)

    
      if (this.modalComponentObject.funcNo != ""){
        this.modalComponentObject.funcNo(this);
      }


    },
    Custom: function(){
      this.$store.dispatch("hideModalComponent");

       const objModal = {
        ok: false,
        cancel: false
      }

      this.$store.commit("SETBUTTONSTATEMODALCOMPONENT", objModal)


      
      if (this.modalComponentObject.funcCustom != ""){
        this.modalComponentObject.funcCustom(this);
      }


    },
    keyup(e){
      alert(e)
    },
    deleteComponent: function(){
      
    }
  }
}
</script>
<style lang="scss">
  
  @import "./../../scss/_modal.scss";
  @import "./../../scss/mixins";
  
  .ModalComponent{
    .modal-body {
      
      scrollbar-width: thin;
    }
    
    
 
    .modal-content {
      
      max-width: 1800px;
      margin: 1rem auto;
      
    }
    
    .modal-xl{
      max-width: 99%;
    }
   
  
  }
  
  
</style>



// WEBPACK FOOTER //
// src/components/shared/ModalComponent.vue